var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHindu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.056 495.056",
    style: {
      enableBackground: "new 0 0 495.056 495.056"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 159.528,
    y: 279.056,
    style: {
      fill: "#5EBC65"
    },
    width: 176,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.528,
    y: 287.056,
    style: {
      fill: "#F9BDA0"
    },
    width: 160,
    height: 168
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M330.376,107.056c0,39.104-29.456,68-65.784,68h-32.328c-36.336,0-65.784-28.896-65.784-68l0,0 c0-39.112,29.448-68,65.784-68h32.328C300.92,39.056,330.376,67.944,330.376,107.056L330.376,107.056z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "307.208,303.056 189.608,303.056 197.464,207.056 299.376,207.056 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "307.224,304.232 260.376,354.928 189.624,207.056 299.384,207.056 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M325.344,138.856c0-68.256-29.816-80.28-77.816-80.552v-0.032v0.016v-0.016v0.032 c-48,0.272-77.816,12.296-77.816,80.544S199.528,268.8,247.528,270.28v0.136c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.136 C295.528,268.808,325.344,207.096,325.344,138.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.528,271.056v-0.64c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.136 c48-1.48,77.816-63.184,77.816-131.432s-29.816-80.272-77.816-80.544v-0.032v0.016v-0.016v-3.216"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M169.48,118.152c-4.216-1.848-3.384-14.36,0.336-22.832c3.736-8.48,10.192-13.84,14.392-11.984 c4.232,1.856,7.728,12.456,0.912,18.704"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M327.344,117.968c4.232-1.864,3.44-14.368-0.28-22.832c-3.712-8.464-10.144-13.816-14.376-11.944 c-4.216,1.864-7.752,12.48-0.928,18.704"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M204.456,219.56c-0.192-0.224-0.304-0.368-0.304-0.368S204.232,219.408,204.456,219.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M247.528,197.336c-8-0.408-22.24,0.28-30.832,11.16c-9.112,11.496-11.664,11.608-12.504,11.072 c1.328,1.432,6.816,6.176,21.504-1.552c10.528-5.536,21.832-6.256,21.832-6.024V197.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M292.376,219.56c0.2-0.224,0.304-0.368,0.304-0.368S292.608,219.408,292.376,219.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M247.528,197.336c8-0.408,23.128,0.28,31.72,11.16c9.104,11.496,12.128,11.608,12.944,11.072 c-1.328,1.432-7.472,6.176-22.184-1.552c-10.504-5.536-14.48-6.256-22.48-6.024V197.336z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB90B"
    },
    d: "M461.056,328.48l-118.464-41.488l2.504-6.968L329.6,273.4c-6.176,27.992-40.528,49.392-82.072,49.392 c-41.56,0-75.896-21.496-82.064-49.488l-15.52,6.488l2.512,6.704L34,328.48L11.528,495.056H41.48h152.744h46.32h13.968h48.464h150.6 h29.952L461.056,328.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8908"
    },
    d: "M15.528,495.056H41.48h152.744h46.32h13.968h48.464h150.6h29.952L461.056,328.48l-118.464-41.488 l2.504-6.968L329.6,273.4c-6.176,27.992-40.528,49.392-82.072,49.392c-41.56,0-75.896-21.496-82.064-49.488l-15.52,6.488l0.512,7.72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E0B"
    },
    d: "M239.528,495.056h14.984h48.464h150.6h29.952L461.056,328.48l-118.464-41.488l2.504-6.968 L329.6,273.4c-6.176,27.992-41.032,50.408-82.584,50.408"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.858,
    y: 244.61,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 604.4763 264.1725)",
    style: {
      fill: "#00233F"
    },
    width: 25.336,
    height: 25.336
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "143.528,495.056 55.528,495.056 55.528,311.864 143.528,283.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#125989"
    },
    points: "55.528,447.056 143.528,447.056 143.528,283.6 55.528,311.864 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#60EAEA"
    },
    points: "55.528,399.056 143.528,399.056 143.528,283.6 55.528,311.864 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#46D0D3"
    },
    points: "55.528,399.056 143.528,399.056 143.528,287.056 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.266,
    y: 365.411,
    transform: "matrix(-0.707 0.7073 -0.7073 -0.707 386.6399 583.1266)",
    style: {
      fill: "#125989"
    },
    width: 12.497,
    height: 12.505
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.522,
    y: 365.411,
    transform: "matrix(-0.7076 0.7066 -0.7066 -0.7076 427.8708 566.274)",
    style: {
      fill: "#125989"
    },
    width: 12.504,
    height: 12.504
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.829,
    y: 365.401,
    transform: "matrix(-0.7068 0.7074 -0.7074 -0.7068 469.5574 548.6929)",
    style: {
      fill: "#125989"
    },
    width: 12.488,
    height: 12.504
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "351.528,495.056 439.528,495.056 439.528,311.864 351.528,283.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#125989"
    },
    points: "439.528,447.056 351.528,447.056 351.528,283.6 439.528,311.864 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#60EAEA"
    },
    points: "439.528,399.056 351.528,399.056 351.528,283.6 439.528,311.864 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#46D0D3"
    },
    points: "439.528,399.056 351.528,399.056 351.528,287.056 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.279,
    y: 365.328,
    transform: "matrix(0.707 0.7073 -0.7073 0.707 386.6211 -189.946)",
    style: {
      fill: "#125989"
    },
    width: 12.497,
    height: 12.505
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.996,
    y: 365.383,
    transform: "matrix(0.7076 0.7066 -0.7066 0.7076 379.0449 -172.741)",
    style: {
      fill: "#125989"
    },
    width: 12.504,
    height: 12.504
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.757,
    y: 365.452,
    transform: "matrix(0.7068 0.7074 -0.7074 0.7068 372.6003 -155.5896)",
    style: {
      fill: "#125989"
    },
    width: 12.488,
    height: 12.504
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M181.392,116.896c0,0,6.088,18.224-2.44,29.168c0,0-2.44,1.216-3.024,6.68 c-0.616,5.48-1.984,21.424,4.4,52.424c2.112,10.272,15.648,38.152,32.664,28.424l6.024,1.824c0,0-3.496,23.712,28.504,23.104 v21.272c0,0-33.384,3.024-55.256-27.36c-21.888-30.384-24.28-73.536-23.672-97.856c0.616-24.32-15.992-36.496-11.128-45.008 C162.336,101.072,181.392,116.896,181.392,116.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M313.664,116.896c0,0-6.088,18.224,2.432,29.168c0,0,2.432,1.216,3.032,6.68 c0.616,5.48,1.984,21.424-4.4,52.424c-2.104,10.272-15.64,38.152-32.656,28.424l-6.024,1.824c0,0,3.488,23.712-28.512,23.104 v21.272c0,0,33.392,3.024,55.256-27.36c21.872-30.384,24.264-73.536,23.672-97.856c-0.616-24.32,15.984-36.496,11.128-45.008 C332.72,101.072,313.664,116.896,313.664,116.896z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB90B"
    },
    d: "M247.528,102.336c40.192,0,75.16,4.856,93.416,12.032c8.56-11.08,13.456-23.808,13.456-37.376 C354.4,34.48,306.56,0,247.528,0S140.64,34.472,140.64,76.992c0,13.568,4.912,26.296,13.472,37.376 C172.368,107.192,207.336,102.336,247.528,102.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8908"
    },
    d: "M140.64,77c0,13.568,4.912,26.296,13.472,37.376c18.256-7.184,53.224-12.04,93.416-12.04 s75.16,4.856,93.416,12.032c8.56-11.08,13.456-23.808,13.456-37.376C354.4,34.48,306.56,0,247.528,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E0B"
    },
    d: "M154.112,114.376c18.256-7.184,53.224-12.04,93.416-12.04s75.16,4.856,93.416,12.032 c8.56-11.08,13.456-23.808,13.456-37.376C354.4,34.48,306.56,0,247.528,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#60EAEA"
    },
    cx: 247.528,
    cy: 53.608,
    rx: 9.256,
    ry: 21.44
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#46D0D3"
    },
    d: "M247.528,32.168c5.112,0,9.248,9.608,9.248,21.44c0,11.84-4.144,21.44-9.248,21.44"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6E0B"
    },
    cx: 247.528,
    cy: 118.904,
    r: 7.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 247.528,
    cy: 366.048,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 247.528,
    cy: 419.616,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 247.528,
    cy: 473.216,
    r: 7.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHindu);
export default __webpack_public_path__ + "static/media/hindu.44c435d9a5fbbdbf6c6a2a5afc3f752e.svg";
export { ForwardRef as ReactComponent };